import { addUnifiedRoutingToUrl, isInUnifiedRouting } from '_shared/helpers/unifiedRoutingHelper';
import { NextRouter, useRouter } from 'next/router';
import { useMemo } from 'react';
import * as urlLib from 'url';
declare type Url = urlLib.UrlObject | string

export function useRelativeRouter() : NextRouter {
  const router = useRouter();

  return useMemo(() => {
    return {
        ...router,
        push: (url: Url, as?: string, options?: any) => {

            if (typeof url === 'object' && !('pathname' in url)) {
                throw new Error('Invalid URL object provided to router.push');
            }
            let oldUrl;
            if (typeof url === 'object')
            {
              oldUrl = urlLib.format(url)
            }
            else{
              oldUrl = url;
            }

            let newUrl = addUnifiedRoutingToUrl(oldUrl);;         
          
            if(as === undefined) {
                router.push(newUrl);
                return;
            }
            
            router.push(newUrl, as, options);
        }
        
    };
  }, [router]) as NextRouter;
}
